export const Constants = {
  api_url: process.env.NEXT_PUBLIC_APIURL,
  main_api_url: process.env.NEXT_PUBLIC_MAIN_APIURL || process.env.NEXT_PUBLIC_APIURL,
  erp_url: process.env.NEXT_PUBLIC_APIAPPURL,
  frontend_url: process.env.NEXT_PUBLIC_FRONTEND_URL,
  console: {
    showAPICalls: process.env.NEXT_PUBLIC_CONSOLESHOWAPICALLS,
  },
  disable_analytics: process.env.NEXT_PUBLIC_DISABLE_ANALYTICS,
  login_cookie: "user_furngroup_login_cookie",
  skip_cache: process.env.NEXT_PUBLIC_SKIP_CACHE == "true",
  dealer_id: process.env.NEXT_PUBLIC_DEALER_ID || null,
};
